import { defaults as _defaults } from 'lodash';
import { Employee } from './Employee';
import { ConvertedMoney, CurrencyType, Money, MoneyTotal } from './Money';
var AllowanceFilter;
(function (AllowanceFilter) {
    AllowanceFilter[AllowanceFilter["All"] = 0] = "All";
    AllowanceFilter[AllowanceFilter["Active"] = 1] = "Active";
    AllowanceFilter[AllowanceFilter["Upcoming"] = 2] = "Upcoming";
    AllowanceFilter[AllowanceFilter["InProgress"] = 3] = "InProgress";
    AllowanceFilter[AllowanceFilter["Past"] = 4] = "Past";
    AllowanceFilter[AllowanceFilter["Inactive"] = 5] = "Inactive";
})(AllowanceFilter || (AllowanceFilter = {}));
const defaultSortModel = {
    field: 'Allowance_StartDate',
    sort: 'desc'
};
const defaultPagination = {
    page: 1,
    pageSize: 25,
    sort: defaultSortModel
};
const AllowanceFilterLabel = new Map([
    [AllowanceFilter.All, 'All'],
    [AllowanceFilter.Active, 'Active'],
    [AllowanceFilter.Upcoming, 'Upcoming'],
    [AllowanceFilter.InProgress, 'In Progress'],
    [AllowanceFilter.Past, 'Past'],
    [AllowanceFilter.Inactive, 'Inactive']
]);
const defaultAllowanceTotals = {
    AllowanceAmount: new Money(),
    DraftTotal: new MoneyTotal(),
    GrandTotal: new MoneyTotal(),
    PendingTotal: new MoneyTotal(),
    ProcessedTotal: new MoneyTotal(),
    RemainingAmount: new MoneyTotal(),
    VarianceAmount: new MoneyTotal()
};
class AllowanceCalculatedTotals {
    AllowanceAmount;
    DraftTotal;
    GrandTotal;
    PendingTotal;
    ProcessedTotal;
    RemainingAmount;
    VarianceAmount;
    constructor(allowanceTotals) {
        _defaults(this, allowanceTotals, defaultAllowanceTotals);
    }
}
const defaultAllowance = {
    Name: '',
    Code: '',
    StartDate: null,
    EndDate: null,
    Amount: new ConvertedMoney(),
    CurrencyType: new CurrencyType(),
    Active: true,
    RequiredForSubmission: false,
    Employee: new Employee(),
    ExpCats: []
};
class Allowance {
    PK;
    Name;
    Code;
    StartDate;
    EndDate;
    Amount;
    CurrencyType;
    Active;
    RequiredForSubmission;
    Employee;
    ExpCats;
    id;
    constructor(allowance) {
        _defaults(this, allowance, defaultAllowance);
    }
}
export { Allowance, AllowanceFilter, AllowanceCalculatedTotals, AllowanceFilterLabel, defaultSortModel, defaultPagination };
